export const PLAYER_STATE = {
    PLAYING: 'playing',
    PAUSED: 'paused',
    STOPPED: 'stopped',
    DURATION: 'duration',
};
